import { computed, makeAutoObservable, toJS } from 'mobx'

import { isGeDomain } from 'utils/helpers/domains/getDomain'
import { Country } from 'shared/types/types'

import { Citizenship, TaxTypes } from '../types'
import { CompanyDetailsViewModel } from './models/CompanyDetailsViewModel'
import { ProfileViewModel } from './models/ProfileViewModel'

export class ValidatePersonalDataStore {
  constructor(
    protected readonly profile: ProfileViewModel,
    protected readonly companyDetails: CompanyDetailsViewModel,
  ) {
    makeAutoObservable(this)
  }

  @computed
  get isInvalidOldPassport() {
    let isInvalid = false
    const company = this.companyDetails
    const citizenship = this.companyDetails.selectedCitizenship.value

    // Обязательные поля для всех стран

    if (
      company.isInvalidPassport ||
      company.isInvalidDateOfIssue ||
      company.isInvalidDateOfBirthday ||
      company.isInvalidPlaceOfBirth ||
      company.documentPhoto.length === 0
    ) {
      isInvalid = true
    }

    // Индивидуальная выборка по полям

    if (
      citizenship === Citizenship.RU &&
      (company.isInvalidDepartmentCode ||
        company.isInvalidRegistrationAddress ||
        company.isInvalidPermanentResidenceAddress)
    ) {
      isInvalid = true
    }

    if (citizenship !== Citizenship.AM && company.isInvalidPassportIssued) {
      isInvalid = true
    }

    if (
      (citizenship === Citizenship.BY || citizenship === Citizenship.KZ) &&
      company.identificationNumber.trim().length === 0
    ) {
      isInvalid = true
    }

    return isInvalid
  }

  @computed
  get isInvalidOldIdentification() {
    let isInvalid = false
    const company = this.companyDetails
    const citizenship = this.companyDetails.selectedCitizenship.value

    // Обязательные поля для всех стран
    if (company.isInvalidDateOfBirthday || company.documentPhoto.length === 0) {
      isInvalid = true
    }
    // Индивидуальная выборка по полям

    if (citizenship !== Citizenship.AM && citizenship !== Citizenship.KZ && company.isInvalidDateOfIssue) {
      isInvalid = true
    }

    if (citizenship === Citizenship.BY && company.isInvalidPlaceOfBirth) {
      isInvalid = true
    }

    if (company.identificationNumber.trim().length === 0) {
      isInvalid = true
    }

    return isInvalid
  }

  @computed
  get isInvalidContactInfo() {
    return (
      this.profile.isInvalidTelegramLogin ||
      this.profile.isInvalidEmail ||
      !this.profile.additionalPhoneModel.isValidPhone ||
      (this.companyDetails.selectedCitizenship.value === Citizenship.RU && this.profile.snils.length !== 11)
    )
  }

  @computed
  get isInvalidIdentificationForm() {
    let isInvalid = false
    const citizenship = this.companyDetails.selectedCitizenship.value
    const company = this.companyDetails

    // Обязательные поля для всех стран
    if (
      this.profile.isInvalidFirstName ||
      this.profile.isInvalidLastName ||
      company.isInvalidDocumentNumber ||
      company.isInvalidDateOfIssue ||
      company.isInvalidExpirationDate ||
      company.isInvalidDateOfBirthday
    ) {
      isInvalid = true
    }

    // Индивидуальная выборка по полям

    if (
      (citizenship === Citizenship.RU || citizenship === Citizenship.BY || citizenship === Citizenship.GE) &&
      company.isInvalidIdentificationNumber
    ) {
      isInvalid = true
    }

    if (
      citizenship === Citizenship.KZ &&
      (company.isInvalidIin || company.isInvalidNationality || company.isInvalidPassportIssued)
    ) {
      isInvalid = true
    }

    if ((citizenship === Citizenship.GE || citizenship === Citizenship.TJ) && company.isInvalidPassportIssued) {
      isInvalid = true
    }

    if (
      !(citizenship === Citizenship.KZ || citizenship === Citizenship.TJ || citizenship === Citizenship.GE) &&
      company.isInvalidDepartmentCode
    ) {
      isInvalid = true
    }

    if (citizenship !== Citizenship.AM && company.isInvalidPlaceOfBirth) {
      isInvalid = true
    }

    if (citizenship === Citizenship.AM && company.isInvalidSocialCardNumber) {
      isInvalid = true
    }

    if ((citizenship === Citizenship.UZ || citizenship === Citizenship.KG) && company.isInvalidPersonalNumber) {
      isInvalid = true
    }

    if (citizenship === Citizenship.TJ && company.isInvalidInnCitizen) {
      isInvalid = true
    }

    return isInvalid
  }

  @computed
  get isInvalidRequisitesData() {
    const { selectedCountry } = this.companyDetails
    const company = this.companyDetails
    let isInvalid = false
    // Обязательные поля для всех стран
    if (
      ((company.taxType === TaxTypes.osn ||
        company.taxType === TaxTypes.lowerRate5 ||
        company.taxType === TaxTypes.lowerRate7) &&
        !toJS(company.hasTaxFiles)) ||
      !company.isValidInn ||
      company.isCompanyNameInvalid ||
      company.isBankNameInvalid ||
      company.isBikInvalid ||
      company.isPayAccountInvalid
    ) {
      isInvalid = true
    }

    // Индивидуальная выборка по странам

    if (selectedCountry.country === Country.BY && company.isInvalidLegalAddress) {
      isInvalid = true
    }

    if (selectedCountry.country === Country.BY && company.gln && company.isInvalidGln) {
      isInvalid = true
    }

    if (!isGeDomain() && selectedCountry.country !== Country.GE && !company.acceptPersonalInfo) {
      isInvalid = true
    }

    if (selectedCountry.country === Country.RU && (company.isCorAccountInvalid || company.isAnBikInvalid)) {
      isInvalid = true
    }

    return isInvalid
  }

  @computed
  get isInvalidPassportForm() {
    let isInvalid = false
    const citizenship = this.companyDetails.selectedCitizenship.value
    const company = this.companyDetails
    // Обязательные поля для всех стран

    if (
      this.profile.isInvalidFirstName ||
      this.profile.isInvalidLastName ||
      company.isInvalidPassport ||
      company.isInvalidDateOfIssue ||
      company.isInvalidGender ||
      company.isInvalidDateOfBirthday
    ) {
      isInvalid = true
    }

    // Индивидуальная выборка по полям

    if (
      (citizenship === Citizenship.BY ||
        citizenship === Citizenship.KZ ||
        citizenship === Citizenship.KG ||
        citizenship === Citizenship.UZ) &&
      company.isInvalidNationality
    ) {
      isInvalid = true
    }

    if (
      (citizenship === Citizenship.BY || citizenship === Citizenship.KG || citizenship === Citizenship.KZ) &&
      company.isInvalidIdentificationNumber
    ) {
      isInvalid = true
    }

    if (citizenship !== Citizenship.RU && company.isInvalidExpirationDate) {
      isInvalid = true
    }

    if (
      (citizenship === Citizenship.RU || citizenship === Citizenship.AM || citizenship === Citizenship.KG) &&
      company.isInvalidDepartmentCode
    ) {
      isInvalid = true
    }

    if (
      citizenship !== Citizenship.AM &&
      citizenship !== Citizenship.KG &&
      (company.isInvalidPassportIssued || company.isInvalidPlaceOfBirth)
    ) {
      isInvalid = true
    }

    if (citizenship === Citizenship.AM && company.isInvalidRegistrationAddress) {
      isInvalid = true
    }

    return isInvalid
  }
}
